module.exports = __webpack_public_path__ + "static/media/orc.09a3fa41.png";